import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminElevatorManager from '../components/AdminElevatorManager';
import FieldManagement from '../components/FieldManagement';
import './AdminPanel.css';

function AdminPanel() {
    const navigate = useNavigate();
    const [currentTab, setCurrentTab] = useState('elevator');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const correctPassword = process.env.REACT_APP_ELEVATOR_PASSWORD;

    const handlePasswordSubmit = (event) => {
        event.preventDefault();

        if (!correctPassword) {
            setErrorMessage('当前环境未配置管理员密码，请检查 REACT_APP_ELEVATOR_PASSWORD。');
            return;
        }

        if (password === correctPassword) {
            setIsAuthenticated(true);
            setErrorMessage('');
            axios.defaults.headers.common['x-admin-password'] = password;
            return;
        }

        setErrorMessage('密码错误，请重新输入。');
    };

    if (!isAuthenticated) {
        return (
            <div className="page-shell admin-login-shell">
                <div className="page-container admin-login-page">
                    <button type="button" className="app-button app-button--secondary" onClick={() => navigate('/')}>
                        返回首页
                    </button>

                    <div className="admin-login-card app-panel app-panel--strong">
                        <div className="admin-login-card__intro">
                            <span className="app-eyebrow">管理员入口</span>
                            <h1>管理控制台</h1>
                            <p>用于维护电梯资料和字段配置。涉及数据库结构的操作请谨慎执行。</p>
                        </div>

                        <form onSubmit={handlePasswordSubmit} className="admin-login-form">
                            <label className="admin-login-form__field">
                                <span>管理员密码</span>
                                <input
                                    type="password"
                                    className="app-input"
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                    placeholder="请输入密码"
                                    required
                                />
                            </label>

                            <button type="submit" className="app-button app-button--primary admin-login-form__submit">
                                登录管理端
                            </button>

                            {errorMessage && (
                                <div className="admin-inline-message admin-inline-message--danger">
                                    {errorMessage}
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-shell">
            <div className="page-container admin-panel">
                <header className="admin-header app-panel">
                    <div className="admin-header__content">
                        <span className="app-eyebrow">后台管理</span>
                        <h1>96333 管理控制台</h1>
                        <p>维护电梯资料、批量导入导出和字段展示规则。</p>
                    </div>

                    <div className="admin-header__actions">
                        <button type="button" className="app-button app-button--secondary" onClick={() => navigate('/')}>
                            返回首页
                        </button>
                        <button
                            type="button"
                            className="app-button app-button--danger"
                            onClick={() => {
                                setIsAuthenticated(false);
                                setPassword('');
                                setErrorMessage('');
                                delete axios.defaults.headers.common['x-admin-password'];
                            }}
                        >
                            退出登录
                        </button>
                    </div>
                </header>

                <nav className="admin-tabs app-panel app-panel--strong" aria-label="管理功能切换">
                    <button
                        type="button"
                        className={`admin-tab ${currentTab === 'elevator' ? 'admin-tab--active' : ''}`}
                        onClick={() => setCurrentTab('elevator')}
                    >
                        电梯管理
                    </button>
                    <button
                        type="button"
                        className={`admin-tab ${currentTab === 'field' ? 'admin-tab--active' : ''}`}
                        onClick={() => setCurrentTab('field')}
                    >
                        字段配置
                    </button>
                </nav>

                <main className="admin-content">
                    {currentTab === 'elevator' ? <AdminElevatorManager /> : <FieldManagement />}
                </main>
            </div>
        </div>
    );
}

export default AdminPanel;
